


















import { Component, Watch, Vue } from 'vue-property-decorator';
import router from '@/router';
import { TMSCustomerAccountService } from '@/services/user';
import { CK_CUSTOMER_ACCOUNT, LocalStorageCache } from '@/services/cache';
import tmsService from '@/services/axios/tmsService';
import tmsTransformRequestService from '@/services/axios/tmsTransformRequestService';

@Component({
  name: 'ClaimsAndDisputes',
})
export default class ClaimsAndDisputes extends Vue {
  private baseUrl: string = this.getBaseUrl();
  private targetUrl: string = '';
  private iframeStyle = {
    width: '100%',
    height: '100%',
    border: 'none',
  };
  // private channel: BroadcastChannel = new BroadcastChannel('Claim&Dispute')
  private wiseUserInfo = {
    oAuthToken: '',
    idmUserId: 0,
  };
  private userInfo: any = null;
  private iframeElement: HTMLIFrameElement | null = null;
  private billingList: any[] = [];
  private isLoading: boolean = false;

  @Watch('$route')
  routeUpdate(val: any) {
    if (val) {
      this.initData();
    }
  }

  async mounted() {
    // console.log('组件开始加载')
    await this.initData();

    // 获取 iframe 元素
    this.iframeElement = this.$refs.iframe as HTMLIFrameElement;

    // 监听 iframe 加载
    if (this.iframeElement) {
      console.log('开始监听 iframe 加载事件');
      this.iframeElement.onload = () => {
        console.log('iframe 加载完成，URL:', this.iframeElement?.src);
        // 尝试发送初始数据
        this.sendDataToIframe();
      };
    }

    // 监听消息
    window.addEventListener('message', (event: MessageEvent) => {
      // 验证消息来源
      if (this.baseUrl && event.origin !== new URL(this.baseUrl).origin) {
        console.warn('收到未知来源的消息，期望来源:', this.baseUrl, '实际来源:', event.origin);
        return;
      }

      this.handleIframeMessage(event);
    });
  }

  beforeDestroy() {
    console.log('beforeDestroy');
  }

  private async handleIframeMessage(event: MessageEvent) {
    console.log('处理消息:', event.data);

    if (event.data.type === 'READY_FOR_DATA') {
      console.log('iframe 已准备好接收数据');
      this.sendDataToIframe();
    } else if (event.data.type === 'DATA_RECEIVED') {
      // 当 iframe 确认收到数据后，关闭 loading
      console.log('iframe 已确认收到数据');
      await new Promise(resolve => setTimeout(resolve, 1000)); // 等待1秒
      this.isLoading = false;
    }
  }

  private async initData() {
    this.isLoading = true; // 开始加载
    console.log('开始初始化数据');
    try {
      let CustomerAccountInfo: any = localStorage.getItem(CK_CUSTOMER_ACCOUNT);
      await this.getWriteNewWiseRefreshLogin();
      let customerInfoList = JSON.parse(CustomerAccountInfo);
      if (customerInfoList.data.billing) {
        this.billingList = [{
          location_id: customerInfoList.data.billing.location_id,
          location_name: customerInfoList.data.billing.location_name,
          location_code: customerInfoList.data.billing.location_code,
        }];
      }
      if (customerInfoList.data.user) {
        this.userInfo = customerInfoList.data.user;
      }
      await new Promise(resolve => setTimeout(resolve, 1000)); // 等待1秒
      this.targetUrl = `${this.baseUrl || ''}?nocache=${new Date().getTime()}`;
      console.log('初始化完成，目标 URL:', this.targetUrl);
    } catch (error) {
      console.error('初始化数据失败:', error);
      this.isLoading = false; // 发生错误时关闭 loading
    }
  }

  private sendDataToIframe() {
    console.log('准备向 iframe 发送数据');

    const iframe = this.iframeElement || document.querySelector('iframe');
    if (!iframe || !iframe.contentWindow || !this.baseUrl) {
      console.warn('发送数据失败:', {
        iframe: !!iframe,
        contentWindow: !!iframe?.contentWindow,
        baseUrl: this.baseUrl,
      });
      this.isLoading = false; // 发送失败时关闭 loading
      return;
    }

    // 发送缓存控制消息
    iframe.contentWindow.postMessage({
      type: 'CACHE_CONTROL',
      payload: {
        cacheControl: 'no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0'
      }
    }, this.baseUrl);

    const data = {
      type: 'INIT_DATA',
      payload: {
        useCustomer: true,
        billingList: this.billingList,
        wiseInfo: this.wiseUserInfo,
        userInfo: this.userInfo,
      },
    };

    // console.log('发送数据到 iframe:', {
    //   targetOrigin: this.baseUrl,
    //   data: data
    // })

    try {
      iframe.contentWindow.postMessage(data, this.baseUrl);
      console.log('数据发送成功，等待 iframe 确认');
      // 注意：这里不立即关闭 loading，等待 iframe 确认收到数据后再关闭
    } catch (error) {
      console.error('发送数据时出错:', error);
      this.isLoading = false; // 发送出错时关闭 loading
    }
  }

  private onMessage(event: MessageEvent) {
    if (event.data === 'UnAuth') {
      router.replace({ name: 'Login' });
    }
  }

  private async getWriteNewWiseRefreshLogin() {
    const customerAccountService = TMSCustomerAccountService.create({
      cache: LocalStorageCache.create(),
      tmsService: tmsService,
      tmsTransformRequestService: tmsTransformRequestService,
    });
    let ret = await customerAccountService.getWriteNewWiseRefreshLogin();
    this.wiseUserInfo.oAuthToken = ret.oAuthToken;
    this.wiseUserInfo.idmUserId = ret.idmUserId;
  }

  private getBaseUrl(): string {
    const host = window.location.hostname;
    console.log('1')
    if (host === 'localhost' || host.includes('dev')) {
      return 'https://stage.logisticsteam.com/crm';
    } else if (host.includes('stage')) {
      return 'https://stage.logisticsteam.com/crm';
    } else {
      return 'https://wise.logisticsteam.com/crm';
    }
    // return ' http://localhost:5173'
    // return 'https://stage.logisticsteam.com/crm'
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/ClaimsAndDisputes/ClaimsAndDisputes.vue